/// <amd-module name="Search/Wiki/Components/Overlay" />

import * as React from "react";
import * as Container from "Search/Shared/Base/Container";
import * as Resources from "Search/Shared/Resources";
import { SearchOverlay } from "Search/Shared/Components/SearchOverlay";
import { SearchStatus } from "Search/Shared/Base/Stores/SearchStore";
import { ActionCreator } from "Search/Wiki/Flux/ActionCreator";
import { StoreName, StoresHub, IAggregatedState } from "Search/Wiki/Flux/StoresHub";

export const OverlayContainer = Container.create<StoreName, ActionCreator, IAggregatedState, StoresHub>(
    ["searchStore"],
    ({ searchStoreState }, props) => {
        const element: JSX.Element | null = searchStoreState.searchStatus === SearchStatus.Loading && !searchStoreState.fetchMoreScenario
            ? <SearchOverlay spinnerText={Resources.FetchingResultsLabel} />
            : null;

        return element;
    });